module.exports = __webpack_public_path__ + "static/img/static_magical_share.adf31bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/static_magical_share.jpg
// module id = aaVL
// module chunks = 0